import { render, staticRenderFns } from "./blog-16.vue?vue&type=template&id=6219bd26&scoped=true"
import script from "./blog-16.vue?vue&type=script&lang=js"
export * from "./blog-16.vue?vue&type=script&lang=js"
import style0 from "./blog-16.vue?vue&type=style&index=0&id=6219bd26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6219bd26",
  null
  
)

export default component.exports